import { useMemo } from "react";
import { IDataTableColumn } from "../../../../../Components/Table/DataTable";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import AtendimentoCard from "../../../../../Components/CardsPages/Atendimento";
import Table from "../../../../../Components/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircle,
    faExchangeAlt,
    faHistory,
    faTrash,
    faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../../../Routes/Acessos";
import HistoricoCardPage from "../../../../../Components/CardsPages/Historico";
import Swal from "sweetalert2";
import {
    ExcluirAtendimentoController,
    RemoverAtendimentoDoUsuarioController,
} from "../../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import BotaoAtenderAtendimento from "../../../Atendimento/BotaoAtenderAtendimento";
import TransferirAtendimento from "../../../../../Components/CardsPages/Atendimento/TransferirAtendimento";
import { TableChangeState } from "react-bootstrap-table-next";
import HTMLRemover from "../../../../../Components/Utils/HTMLRemover";
import { IAssistenciaTecnicaMapeado } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import { useUserInfor } from "../../../../../Context/User";
interface IPropsTableChange extends TableChangeState<any> {
    searchText: string;
}

export default function TableAtendimentosAssistencia(props: any) {
    //tabela
    const { UserInfor } = useUserInfor();
    function rowAtendimento(cell: any, row: IAssistenciaTecnicaMapeado) {
        return (
            <AtendimentoCard
                atendimento={row}
                setModal={props.setModal}
                setShow={props.setShow}
                moduloAtendimento="AssistenciaTecnica"
                hideHistoricoNumber
            >
                <div className="d-flex flex-column mt-3 flex-grow-1">
                    <label className="text-center text-dark font-weight-bold my-1 mr-5">
                        Assistência Técnica
                    </label>
                    <div className="border-right border-left fixheigth border-3 border-warning">
                        <div className="d-flex flex-wrap align-items-center justify-content-center h-100">
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Protocolo
                                    </div>
                                    <label>{row.ID_CASO}</label>
                                </div>
                            </div>
                            {/*
                             <div className="px-4 py-3">
                                 <div className="font-size-h5 font-weight-bolder text-center">
                                     <div className="font-size-sm text-muted font-weight-bold">Descrição</div>
                                     <label>
                                        {row.DS_CASO}
                                     </label>
                                 </div>
                             </div>
                             <div className="px-4 py-3">
                                 <div className="font-size-h5 font-weight-bolder text-center">
                                     <div className="font-size-sm text-muted font-weight-bold">Dt. Abertura</div>
                                     <label>
                                        {new Date(row.DT_INICIO).toLocaleDateString()}
                                     </label>
                                 </div>
                             </div>
                             <div className="px-4 py-3">
                                 <div className="font-size-h5 font-weight-bolder text-center">
                                     <div className="font-size-sm text-muted font-weight-bold">Dt. Fechamento</div>
                                     <label>
                                        {row.DT_FIM}
                                     </label>
                                 </div>
                             </div>
                            */}
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Tipo Canal
                                    </div>
                                    <label>{row.DS_CANAL_ATENDIMENTO}</label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Categoria Atendimento
                                    </div>
                                    <label>
                                        {
                                            row.AssisTec
                                                .DS_CATEGORIA_ATENDIMENTO_COMP
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Etapa
                                    </div>
                                    <label>{row.AssisTec.DS_ETAPA}</label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Cliente
                                    </div>
                                    <label>{row.CONTA.DS_NOME}</label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Contato
                                    </div>
                                    <label>{row.CONTA.DS_CONTATO}</label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Garantia
                                    </div>
                                    <label>
                                        {row.AssisTec.FL_GARANTIA
                                            ? "Dentro da garantia"
                                            : "Fora da garantia"}
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Recorrencia
                                    </div>
                                    <label>
                                        {row.AssisTec.FL_CASO_RECORRENTE
                                            ? "Caso recorrente"
                                            : "Caso não recorrente"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AtendimentoCard>
        );
    }
    const tableColumns: Array<IDataTableColumn<IAssistenciaTecnicaMapeado>> =
        useMemo(
            () => [
                {
                    dataField: "Ver Caso",
                    text: "",
                    isDummyField: true,
                    formatter: (_, row) => {
                        const css = `
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} {
                    color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                    background-color: transparent;
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover {
                    color: #ffffff !important;
                    background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} i {
                    color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                    background-color: transparent;
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover i {
                    color: #ffffff !important;
                    background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
            `;

                        return (
                            <>
                                <style>{css}</style>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-atendimento-tooltip">
                                            Ver Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <Link
                                        to={ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK(
                                            row.ID_CASO
                                        )}
                                        className={`m-2 btn btn-icon ${
                                            row.PESO_ATENDIMENTO
                                                ?.HX_COR_PESO_ATENDIMENTO
                                                ? `button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}`
                                                : "btn-outline-info"
                                        }`}
                                    >
                                        <i
                                            className={`icon-xl ${
                                                row.PESO_ATENDIMENTO
                                                    ?.DS_ICON_PESO_ATENDIMENTO
                                                    ? `${row.PESO_ATENDIMENTO?.DS_ICON_PESO_ATENDIMENTO}`
                                                    : "far fa-eye"
                                            } `}
                                        ></i>
                                    </Link>
                                </OverlayTrigger>
                            </>
                        );
                    },
                    style: (cell, row) => {
                        if (row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO)
                            return {
                                borderLeft: `8px solid ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO}`,
                            };
                        else return {};
                    },
                },
                {
                    headerAlign: "center",
                    dataField: "ID_OCORRENCIA",
                    text: "Ocorrência",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "ID_CASO",
                    text: "Protocolo",
                    align: "center",
                    formatter: (c, row) => (
                        <>
                            {c}
                            <label
                                className="mb-0"
                                style={{
                                    color: row.PESO_ATENDIMENTO
                                        ?.HX_COR_PESO_ATENDIMENTO,
                                }}
                            >
                                {" "}
                                {
                                    row.PESO_ATENDIMENTO
                                        ?.DS_TIPO_PESO_ATENDIMENTO
                                }{" "}
                            </label>{" "}
                            {/* {row.FL_CASO_RECORRENTE && (
                                <label
                                    className="mb-0"
                                    style={{
                                        color: row.PESO_ATENDIMENTO
                                            ?.HX_COR_PESO_ATENDIMENTO,
                                    }}
                                >
                                    Recorrente
                                </label>
                            )} */}
                        </>
                    ),
                },
                {
                    headerAlign: "center",
                    dataField: "DS_CASO",
                    text: "Descrição",
                    align: "center",
                    formatter: (c) => (
                        <HTMLRemover charLimit={40}>{c}</HTMLRemover>
                    ),
                },

                {
                    headerAlign: "center",
                    dataField: "DS_STATUS_SOLICITACAO",
                    text: "Status",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DT_INICIO",
                    text: "Dt. Abertura",
                    align: "center",
                    formatoPadrao: "date",
                    formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
                },
                {
                    headerAlign: "center",
                    dataField: "DT_VISTORIA",
                    text: "Dt. Vistoria",
                    align: "center",
                    formatoPadrao: "date",
                    formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
                },
                {
                    headerAlign: "center",
                    dataField: "DT_REPARO",
                    text: "Dt. Reparo",
                    align: "center",
                    formatoPadrao: "date",
                    formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
                },
                {
                    headerAlign: "center",
                    dataField: "DT_FIM",
                    text: "Dt. Fechamento",
                    align: "center",
                    formatoPadrao: "date",
                    formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
                },
                {
                    headerAlign: "center",
                    dataField: "DS_COMODO",
                    text: "Cômodo",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_TIPO_CANAL_ATENDIMENTO",
                    text: "Canal",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_PRODUTO_COMP",
                    text: "Produto",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_CATEGORIA_ATENDIMENTO_COMP",
                    text: "Categoria",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_ETAPA",
                    text: "Etapa",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_USUARIO_RESPONSAVEL",
                    text: "Atendente",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_CONTA",
                    text: "Cliente",
                    align: "center",
                },
                {
                    headerAlign: "center",
                    dataField: "DS_CONTATO",
                    text: "Contato",
                    align: "center",
                },
                {
                    dataField: "NR_DIAS_ATRASO",
                    text: "SLA",
                    formatter: (c) => (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    {" "}
                                    {c < 0 ? (
                                        <>{Math.abs(c)} Dias para Vencer</>
                                    ) : (
                                        <>{c} Dias em Atraso SLA</>
                                    )}
                                </Tooltip>
                            }
                        >
                            <FontAwesomeIcon
                                icon={faCircle}
                                size="1x"
                                className={`text-${
                                    c < 0
                                        ? "success"
                                        : c === 0
                                        ? "warning"
                                        : "danger"
                                }`}
                            />
                        </OverlayTrigger>
                    ),
                },
                {
                    dataField: "",
                    text: "",
                    isDummyField: true,
                    formatter: (_, row) => (
                        <div className="d-flex g-2 p-2">
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="historico-tooltip">
                                        Histórico do Caso
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-primary"
                                    onClick={() => {
                                        props.setModal({
                                            Component: () =>
                                                HistoricoCardPage({
                                                    ID_CASO: row.ID_CASO,
                                                }),
                                            headerComponent: "Históricos",
                                            IconHeader: faHistory,
                                            collapseForm: true,
                                            size: "lg",
                                        });
                                        props.setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faHistory} />
                                </button>
                            </OverlayTrigger>
                        </div>
                    ),
                },
                {
                    dataField: "",
                    text: "",
                    isDummyField: true,
                    formatter: (_, row) => (
                        <div className="d-flex g-2 p-2">
                            {UserInfor.FUNCOES.some(
                                (f) =>
                                    f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="transferir-tooltip">
                                            Transferir Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-warning"
                                        onClick={() => {
                                            props.setShow(true);
                                            props.setModal({
                                                Component: () => (
                                                    <TransferirAtendimento
                                                        ID_CASO={row.ID_CASO}
                                                        setShow={props.setShow}
                                                        update={() =>
                                                            props.execute()
                                                        }
                                                        ID_TIPO_CASO={
                                                            ACESSOS.ASSISTENCIA
                                                                .ID_MODULO
                                                        }
                                                    />
                                                ),
                                                IconHeader: faExchangeAlt,
                                                headerComponent:
                                                    "Transferir Atendimento",
                                            });
                                        }}
                                        disabled={
                                            row.AssisTec.FL_SINCRONIZADO ===
                                            false
                                        }
                                    >
                                        <FontAwesomeIcon icon={faExchangeAlt} />
                                    </button>
                                </OverlayTrigger>
                            )}
                            <div>
                                {/*
                    (UserInfor.FUNCOES.some(( f => f.NM_FUNCAO === 'ADM_GERENCIAR_ATENDENTES'))) &&
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="transferir-tooltip">Transferir Atendimento</Tooltip>
                        }
                    >
                            <button className="btn btn-icon btn-outline-warning" onClick={() => {
                                setModal({
                                    Component: () => 
                                        <TransferirAtendimento 
                                            ID_CASO={row.ID_CASO} 
                                            ID_TIPO_CASO={ACESSOS.ATENDIMENTO.ID_MODULO}
                                            setShow={setShow} 
                                            update={()=>{updateAtendimentos(filter,1,row.AssisTec)}}
                                            ID_USUARIO={row.AssisTec.ID_USUARIO}
                                            ID_USUARIO_ACOMPANHAMENTO={row.AssisTec.ID_USUARIO_ACOMPANHAMENTO}
                                        />,
                                    IconHeader: faExchangeAlt,
                                    headerComponent: "Transferir Atendimento"
                                })
                                setShow(true)
                            }}>
                                <FontAwesomeIcon icon={faExchangeAlt}/>
                            </button>
                    </OverlayTrigger>
                        */}
                            </div>
                            {!row.DS_USUARIO_RESPONSAVEL ? (
                                <BotaoAtenderAtendimento
                                    then={() =>
                                        props.execute(
                                            {
                                                ...props.filter,
                                            },
                                            1,
                                            row.AssisTec
                                        )
                                    }
                                    ID_CASO={row.ID_CASO}
                                    row={row}
                                />
                            ) : (
                                <div>
                                    {UserInfor.FUNCOES.some(
                                        (f) =>
                                            f.NM_FUNCAO ===
                                            "ADM_GERENCIAR_ATENDENTES"
                                    ) && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="remover-tooltip">
                                                    Remover Atendente
                                                </Tooltip>
                                            }
                                        >
                                            <button
                                                className="btn btn-icon btn-outline-danger"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: `Deseja remover o vínculo de ${row.DS_ATENDENTE} a este atendimento?`,
                                                        icon: "info",
                                                        buttonsStyling: false,
                                                        confirmButtonText:
                                                            "<i class='la la-check'></i> Sim!",
                                                        showCancelButton: true,
                                                        cancelButtonText:
                                                            "<i class='la la-thumbs-down'></i> Não",
                                                        customClass: {
                                                            confirmButton:
                                                                "btn btn-outline-success",
                                                            cancelButton:
                                                                "btn btn-default",
                                                        },
                                                    }).then((result) => {
                                                        if (
                                                            result.isConfirmed
                                                        ) {
                                                            RemoverAtendimentoDoUsuarioController(
                                                                row.ID_CASO
                                                            ).then(() => {
                                                                props.execute(
                                                                    props.filter,
                                                                    1,
                                                                    row.AssisTec
                                                                );
                                                            });
                                                        }
                                                    });
                                                }}
                                                disabled={
                                                    row.AssisTec
                                                        .FL_SINCRONIZADO ===
                                                    false
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faUserTimes}
                                                />
                                            </button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            )}
                            {UserInfor.FUNCOES.some(
                                (f) => f.NM_FUNCAO === "ADM_EXCLUIR_CASO"
                            ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="historico-tooltip">
                                            Excluir Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-dark"
                                        onClick={() => {
                                            Swal.fire({
                                                title: `Deseja excluir esse Atendimento? <br/> <br/> Caso: ${row.ID_CASO}`,
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    ExcluirAtendimentoController(
                                                        row.ID_CASO,
                                                        UserInfor.ID_USUARIO ??
                                                            0
                                                    ).then(() => {
                                                        props.execute(
                                                            props.filter,
                                                            1,
                                                            props.atendimento
                                                        );
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </OverlayTrigger>
                            )}
                        </div>
                    ),
                },
            ],
            [props, UserInfor.FUNCOES, UserInfor.ID_USUARIO]
        );
    //tabela
    const atendimentoColumns: Array<
        IDataTableColumn<IAssistenciaTecnicaMapeado>
    > = [
        {
            dataField: "ID_CASO",
            text: "ID",
            formatter: rowAtendimento,
            headerClasses: "d-none",
        },
    ];

    return (
        <>
            {props.lstAtendimentos?.ATENDIMENTOS ? (
                <Table
                    columns={atendimentoColumns}
                    data={props.lstAtendimentos.ATENDIMENTOS ?? []}
                    keyField="ID_CASO"
                    loading={props.loading}
                    remote={{ pagination: true }}
                    totalPages={props.totalPaginas}
                    noDataIndication={
                        <div className="text-center text-black-50">
                            Nenhum atendimento encontrada
                        </div>
                    }
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;

                        if (state.searchText !== "") {
                            props.handleSearch(
                                state.searchText,
                                state
                                // naoContem
                            );
                            props.setPesquisaText(state.searchText);
                        } else if (props.pesquisaText.length > 0) {
                            props.setFilter({
                                PESQUISA: state.searchText,
                            });
                        } else {
                            props.setPage(state.page);
                        }
                    }}
                    tableView={{
                        columns: tableColumns,
                        noSort: true,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                    }}
                    bordered={false}
                    noHover
                />
            ) : (
                <SpinnerComponent />
            )}
        </>
    );
}
